/**
 * Created by buddy on 2020-07-23.
 */
import * as React from 'react';

export const RemoveLiquidity = React.createContext(null);
